import React, { memo, useCallback } from 'react';

import { Box } from '@mui/material';
import { ArrowCheckIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconDirection, IconSize } from 'constants/coreDesignSystem';

import { recipientCopiesToggleStyles } from './DocumentRecipientCopiesToggle.styles';
import { DocumentRecipientCopiesToggleTestIds } from './DocumentRecipientCopiesToggle.testIds';
import {
  getRecipientCopiesCountLabel,
  getRecipientCopiesToggleLabel,
} from './DocumentRecipientCopiesToggle.utils';

const DocumentRecipientCopiesToggle = ({ count, documentId, isExpanded, onToggle }) => {
  const onClick = useCallback(
    e => {
      e.stopPropagation();
      onToggle(documentId);
    },
    [documentId, onToggle],
  );

  // stopPropagation keeps the master row's drag from arming; preventDefault keeps the button
  // from taking focus away from the tree item, which would stop the tree's arrow-key handling.
  const onMouseDown = useCallback(e => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  return (
    <Box
      aria-expanded={isExpanded}
      aria-label={getRecipientCopiesToggleLabel({ count, isExpanded })}
      component="button"
      data-testid={DocumentRecipientCopiesToggleTestIds.getToggleId(documentId)}
      sx={recipientCopiesToggleStyles}
      tabIndex={-1}
      type="button"
      onClick={onClick}
      onMouseDown={onMouseDown}
    >
      <ArrowCheckIcon
        direction={isExpanded ? IconDirection.DOWN : IconDirection.RIGHT}
        size={IconSize[16]}
      />
      <Box className="text-11" component="span">
        {getRecipientCopiesCountLabel(count)}
      </Box>
    </Box>
  );
};

DocumentRecipientCopiesToggle.propTypes = {
  count: PropTypes.number.isRequired,
  documentId: PropTypes.string.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default memo(DocumentRecipientCopiesToggle);
